import script from "./DrawSwitch.vue?vue&type=script&setup=true&lang=ts"
export * from "./DrawSwitch.vue?vue&type=script&setup=true&lang=ts"

import "./DrawSwitch.vue?vue&type=style&index=0&id=6b1db8eb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b1db8eb"]])

export default __exports__